










import { IUser } from 'src/laura-types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class Welcome extends Vue {
  @Prop({ required: true, type: Object }) public user!: IUser

  get fullName(): string {
    if (this.user.preposition === '') return this.user.first_name + ' ' + this.user.surname

    return this.user.first_name + ' ' + this.user.preposition + ' ' + this.user.surname
  }
}
